import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DiaryCalendarView } from "./../../models/diary-calendar-view";
import { DatePipe } from '@angular/common';

@Component({
  selector: 'mojo-calendar-navigator',
  templateUrl: './calendar-navigator.component.html',
  styleUrls: ['./calendar-navigator.component.scss']
})
export class CalendarNavigatorComponent implements OnInit {
  @Input() view: DiaryCalendarView;
  @Input() date: Date;

  @Output() leftChevronClicked = new EventEmitter<any>();
  @Output() rightChevronClicked = new EventEmitter<any>();
  @Output() barClicked = new EventEmitter<any>();

  prevChevronClicked() {
    this.leftChevronClicked.emit();
  }

  nextChevronClicked() {
    this.rightChevronClicked.emit();
  }

  titleBarClicked() {
    this.barClicked.emit();
  }

  getTitle() {
    var dateFormat: string = 'MMMM yyyy';

    switch (this.view) {
      case DiaryCalendarView.Duodecennial:
        {
          let startYear = Math.floor(this.date.getUTCFullYear() / 12) * 12;
          let endYear = startYear + 11;
          return startYear + " - " + endYear;
      }
      case DiaryCalendarView.Year:
      {
        dateFormat = 'yyyy';
        break;
      }
      case DiaryCalendarView.Month:
      {
        dateFormat = 'MMMM yyyy';
        break;
      }
      case DiaryCalendarView.Day:
      {
        dateFormat = 'dd MMMM yyyy';
        break;
      }
      default:
    }
    return this.datePipe.transform(this.date, dateFormat);
  }

  constructor(private datePipe: DatePipe) { }

  ngOnInit() {
  }

}
